export default __webpack_public_path__ + "static/media/tmp_fincar_image01.1c8d6cbb.png";